module.exports = __webpack_public_path__ + "media/images/views/lp/home/banner-home-db0a3e2a9471fca848c5e0e62a08247e.jpg";